<template>
  <NuxtLayout name="catalog">
    <div class="page-loyalty-program">
      <div class="page-container">
        <MoleculesGlobalBreadcrumb :segments="props.breadcrumbSegments" :show-all-segments="true" />
      </div>

      <div class="page-info__heading">
        <div class="page-container">
          <h1>{{ entity.page.header }}</h1>

          <div class="content-2-col mt-12 mb-6 mx-auto max-w-[740px] bg-neutral-100">

            <AtomsContainersCornerBorders class="p-6 self-stretch flex flex-col gap-4 text-center bg-neutral-50">
              <AtomsImagesIcon icon="loyalty-program" class="my-4 text-[4rem]" />
              <strong class="text-xl font-bold mb-auto">{{ $t('Věrnostní program pro věrné zákazníky') }}</strong>
              <p>{{ $t('Nakupujete rádi a často army, outdoor a survival vybavení a chcete na vašich nákupech ušetřit? Pak je náš věrnostní program určený přesně pro vás!') }}</p>
              <MoleculesButtonsButton href="#customers" class="mt-auto w-full">{{ $t('Dozvědět se více') }}</MoleculesButtonsButton>
            </AtomsContainersCornerBorders>

            <AtomsContainersCornerBorders class="p-6 self-stretch flex flex-col gap-4 text-center bg-neutral-50">
              <AtomsImagesIcon icon="person-card" class="my-4 text-[4rem]"  />
              <strong class="text-xl font-bold mb-auto">{{ $t('Slevy pro členy organizací a klubů') }}</strong>
              <p>{{ $t('Jste členy státních ozbrojených složek, záchranářů, bezpečnostních agentur, sportovních klubů, či jiných organizací? Pak můžete kupovat za výhodnější ceny ihned!') }}</p>
              <MoleculesButtonsButton href="#associations" class="mt-auto w-full">{{ $t('Dozvědět se více') }}</MoleculesButtonsButton>
            </AtomsContainersCornerBorders>

          </div>
        </div>
      </div>

      <div class="page-info__wrapper">
        <div class="page-info--loyalty-program">
          <MoleculesBlocksInfoPageElement :element="mappedContent[0]" />
        </div>
      </div>

    </div>

  </NuxtLayout>
</template>
<script setup>

const props = defineProps({
  breadcrumbSegments: Array
});

const appConfig = useAppConfig();
const entity = useEntity();
const locale = useLocale().getLocale();
const cache = useCache();
const i18n = useI18n();
const content = useContent();
const page = usePage().value.page;

const mappedContent = content.transformHtmlContent(entity.content, page.id);

</script>